<template>
  <div class="pb-5">
    <div class="d-flex align-center">
      <div class="black--text">Chat History</div>
      <v-spacer></v-spacer>
      <v-btn
        @click="$emit('expand')"
        text
        class="px-0"
        :color="isExpanded ? 'red' : 'primary'"
      >
        {{ isExpanded ? "Close" : "Expand" }}</v-btn
      >
    </div>
    <div class="chat-history">
      <div v-for="chat in chats" :key="chat.id" class="black--text d-flex">
        <span style="white-space: nowrap" class="mr-1 font-weight-bold">
          {{ uid == chat.uid ? "Me:" : `${chat.name}:` }}
        </span>
        <span v-html="chat.message"> </span>
      </div>
    </div>
    <please-wait v-if="isChatLoading" />
    <div class="d-flex mt-2">
      <div class="flex-grow-1">
        <textarea v-model="input" class="chat-editor"></textarea>
      </div>
      <v-btn depressed @click="submit()" class="primary ml-3" :loading="loading"
        >Send</v-btn
      >
    </div>
  </div>
</template>

<script>
import {addDoc, collection} from "firebase/firestore";
import PleaseWait from "../ui/PleaseWait.vue";
import {colTeamSchedules} from "@/assets/utils/firebase.utils";
import {getDate} from "@/assets/utils/common.utils";

export default {
  components: { PleaseWait },
  props: {
    taskId: String,
    isExpanded: Boolean,
    isChatLoading: Boolean,
    chats: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      input: "",
      loading: false,
    };
  },
  watch: {
    chats() {
      console.log("Chats...");
      this.$nextTick(() => {
        const chatBox = document.querySelector(".chat-history");
        if (chatBox) {
          chatBox.scrollTop = chatBox.scrollHeight;
        }
      });
    },
  },
  computed: {
    fields() {
      console.log("users", this.$store.getters.members);
      return [...this.$store.getters.members].map((i) => ({
        value: i.id,
        text: `${i.first_name} ${i.last_name}`,
      }));
    },
    options() {
      return {
        height: 80,
        menubar: false,
        toolbar: false,
        statusbar: false,
        plugins: ["upload-images"],
        browser_spellcheck: true,
        content_style:
          ".mention-item { background: #091e420f !important;border-radius: 20px;padding: 3px 8px;}",
        setup: (editorItem) => {
          const vm = this;
          editorItem.on("keydown", function (e) {
            let menu = document.querySelector(".tox-autocompleter");
            if (e.key === "Enter" && !e.shiftKey && menu == null) {
              e.preventDefault();
              vm.submit();
            }
          });
          const emitContent = () => {
            setTimeout(() => {
              const content = editorItem.getContent();
              vm.input = content;
              vm.$emit("input", content);
            }, 0);
          };

          editorItem.on("Change", emitContent);
          editorItem.on("Input", emitContent);
          editorItem.on("ExecCommand", emitContent);
          editorItem.on("NodeChange", emitContent);
          window.tinymce.PluginManager.add("upload-images", (editor) => {
            const getMatchedChars = (pattern) => {
              return vm.fields.filter(
                (char) =>
                  char.text.toLowerCase().indexOf(pattern.toLowerCase()) !== -1
              );
            };
            const onAction = (autocompleteApi, rng, value) => {
              editor.selection.setRng(rng);
              let hit = vm.fields.find((item) => item.value == value);
              editor.insertContent(
                `<label contentEditable="false" spellcheck="false" class="mention-item" data-id="${hit.value}">@${hit.text}</label> &nbsp;`
              );
              autocompleteApi.hide();
              vm.input = editor.getContent();
              vm.$emit("input", vm.input);
            };

            editor.ui.registry.addAutocompleter("specialchars", {
              ch: "@",
              minChars: 0,
              columns: 1,
              onAction: onAction,
              fetch: (pattern) => {
                return new Promise((resolve) => {
                  const results = getMatchedChars(pattern).map((char) => ({
                    type: "cardmenuitem",
                    value: char.value,
                    label: char.text,
                    items: [
                      {
                        type: "cardcontainer",
                        direction: "vertical",
                        items: [
                          {
                            type: "cardtext",
                            text: char.text,
                            name: "char_name",
                          },
                        ],
                      },
                    ],
                  }));
                  resolve(results);
                });
              },
            });
          });
        },
      };
    },
  },
  methods: {
    async submit() {
      if (!this.input) return;
      try {
        this.loading = true;
        let chatRef = collection(colTeamSchedules, this.taskId, "chats");
        await addDoc(chatRef, {
          message: this.input,
          name: `${this.user.first_name} ${this.user.last_name}`,
          uid: this.uid,
          created_at: getDate(),
        });
        this.input = "";
        // eslint-disable-next-line no-undef
        if (tinymce.activeEditor) {
          // eslint-disable-next-line no-undef
          tinymce.activeEditor.setContent("");
        }
        this.loading = false;
      } catch (error) {
        this.handleError(error);
      }
    },
  },
  mounted() {
    const vm = this;
    vm.input = vm.value || "";
    vm.$nextTick(() => {
      // eslint-disable-next-line no-undef
      tinymce.init({
        ...{
          selector: ".chat-editor",
        },
        ...vm.options,
      });
    });
  },
};
</script>

<style lang="scss">
.mention-item {
  background: #091e420f !important;
  border-radius: 20px;
  padding: 3px 8px;
}
.chat-history {
  overflow-y: auto;
  max-height: 210px;
  p {
    margin-bottom: 8px;
  }
}
</style>
